import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import instance from "@services/services";
const { clinicId } = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{stateResponseDtos:MasterTableDataType[],totatCount:number}>>=>{
    const result = await instance.post(`${MastersApi.getAllState}`,{...params,clinicId});
    return result.data;
}

export const deleteMasterData = async (id:number):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.delete(`${MastersApi.deleteState}${id}`);
    return result.data;
}

export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.saveState}`,params);
    return result.data;
}

